import React, { useEffect, useState } from "react";
import Header from "../Header";
import Sidebar from "../Sidebar";
import { Link, useLocation, useNavigate } from "react-router-dom";
import FeatherIcon from "feather-icons-react/build/FeatherIcon";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { useQuery } from "@tanstack/react-query";
import Select from "react-select";
import { getDoctor } from "../../connections/getDoctor";
import { getStaffList } from "../../connections/getStaffList";
import { putAssign } from "../../connections/putAssign";

const UpdateQuery = () => {

  const navigate = useNavigate();
  const location = useLocation();
  const QueryData = location.state || null;

  const {
    user: { user },
  } = useSelector((store) => store);

  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(50);


  const {
    data: getDoctorData,
    // isLoading: doctorLoader,
    // refetch: refetchDoctorList,
  } = useQuery({
    queryKey: ["getDoctor", page, pageSize],
    queryFn: () => getDoctor(user?.token, null, page, pageSize),
    refetchOnWindowFocus: false, // Don't refetch when window regains focus
    refetchOnReconnect: false, // Don't refetch when reconnecting
  });


  const {
    data: getStaffListData,
    // isLoading: staffLoader,
    // refetch: refetchStaff,
  } = useQuery({
    queryKey: ["getStaffList", page, pageSize],
    queryFn: () => getStaffList(user?.token, null, page, pageSize),
    enabled: !!user?.token,
    refetchOnWindowFocus: false, // Don't refetch when window regains focus
    refetchOnReconnect: false, // Don't refetch when reconnecting
  });

  const [formState, setFormState] = useState({
    assigned_to_type: null,
    assigned_to_id: null,
    status: null,
    // query_replies_attributes: ['']
  });

  // setFormState((prev) => ({ ...prev }))

  const doctorsList = getDoctorData?.payload?.specialists?.map((item) => ({
    value: item?.id,
    label: item?.first_name + " " + item?.last_name,
  })) || [];

  const staffList = getStaffListData?.payload?.backops_users?.map((item) => ({
    value: item?.id,
    label: item?.first_name + " " + item?.last_name,
  })) || [];


  // console.log(QueryData, 'QueryData')
  // console.log(getStaffListData, 'getStaffListData')
  // console.log(getDoctorData, 'getDoctorData')

  const handleChange = (name, value) => {
    if (name === 'assigned_to_type' && formState?.assigned_to_type) {
      setFormState((prevData) => ({
        ...prevData,
        ['assigned_to_id']: null,
      }));
    }

    setFormState((prevData) => ({
      ...prevData,
      [name]: value,
    }));


  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    // console.log(formState, formState?.account_ids?.length);
    if (!formState?.assigned_to_type) {
      toast.error("Assigned type is required");
      return;
    }

    if (!formState?.assigned_to_id) {
      toast.error("Assigned to  is required");
      return;
    }

    const payload = {
      query: {
        ...formState,
        ...(message && { query_replies_attributes: [{ message }] }), // Include key only if message is truthy
      },
    };

    try {
      const result = await putAssign(
        user?.token,
        payload,
        QueryData?.id
      );
      if (result?.status?.status === "SUCCESS") {
        toast.success("Query Updated Successfully");
        navigate("/admin/Quires");
        setFormState({
          assigned_to_type: null,
          assigned_to_id: null,
          status: null,
          // query_replies_attributes: ['']
        });
      }
    } catch (error) {
      // toast.error(error.message);
      console.log(error.message);
    }
  };


  const [assignTypeOptions] = useState([
    { value: "Doctor", label: "Doctor" },
    // { value: "Specialist", label: "Specialist" },
    { value: "BackopsUser", label: "Backops user" },
  ]);

  const [statusList] = useState([
    { value: "open", label: "Open" },
    { value: "in_progress", label: "in progress" },
    { value: "resolved", label: "Resolved" },
    { value: "closed", label: "Closed" },
  ]);




  useEffect(() => {
    if (QueryData) {
      setFormState({
        assigned_to_type: QueryData?.assigned_to?.type === "Specialist" ? "Doctor" : QueryData?.assigned_to?.type,
        assigned_to_id: QueryData?.assigned_to?.id,
        status: QueryData?.status,
        // "query_replies_attributes": [
        //   { "message": "We are investigating the issue."}
        // ]
      });
      setMessages(QueryData?.query_replies);
    }
    setPage(1);
    setPageSize(50);
  }, [QueryData]);
  //   console.log(formState, accountOptions);

  //  const [message, setMessage] = useState("");
  const [message, setMessage] = useState("");
  const [messages, setMessages] = useState(QueryData?.query_replies || []);

  return (
    <>
      <Header />
      <Sidebar activeClassName="quires" />
      <div className="page-wrapper">
        <div className="content">

          <div className="page-header">
            <div className="row">
              <div className="col-sm-12">
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to={-1}>Query</Link>
                  </li>
                  <li className="breadcrumb-item">
                    <i className="feather-chevron-right">
                      <FeatherIcon icon="chevron-right" />
                    </i>
                  </li>
                  <li className="breadcrumb-item active">Update Query </li>
                </ul>
              </div>
            </div>
          </div>


          <div className="row">
            <div className="col-sm-12">
              <div className="card">
                <div className="card-body">
                  <div className="col-12">
                    <div className="form-heading">
                      <h4>Update Query</h4>
                    </div>
                  </div>



                  <div className="card-box mb-0">
                    <div className="card-block">
                      <ul className="personal-info">
                        <li className="pb-1">
                          <span className="title">Id:</span>{" "}
                          <span className="text">
                            {QueryData?.id || "Empty"}
                          </span>
                        </li>
                        <li className="pb-1">
                          <span className="title">Title:</span>{" "}
                          <span className="text">
                            {QueryData?.title || "Empty"}
                          </span>
                        </li>
                        <li className="pb-1">
                          <span className="title">Description:</span>{" "}
                          <span className="text">
                            {QueryData?.description || "Empty"}
                          </span>
                        </li>

                      </ul>
                    </div>
                  </div>

                  <form onSubmit={handleSubmit}>
                    <div className="row">

                      <div className="col-12 col-md-6 col-xl-6">
                        <div className="form-group local-forms">
                          <label>
                            Assigned type <span className="login-danger">*</span>
                          </label>
                          <Select
                            value={assignTypeOptions.find(
                              (option) =>
                                option.value === formState?.assigned_to_type
                            )}
                            onChange={(e) =>
                              handleChange("assigned_to_type", e.value)
                            }
                            options={assignTypeOptions}
                            id="search-commodity"
                            components={{
                              IndicatorSeparator: () => null,
                            }}
                            styles={{
                              menu: (base) => ({ ...base, zIndex: 9999 }),
                              control: (baseStyles, state) => ({
                                ...baseStyles,
                                borderColor: state.isFocused
                                  ? "none"
                                  : "2px solid rgba(46, 55, 164, 0.1);",
                                boxShadow: state.isFocused
                                  ? "0 0 0 1px #007A99"
                                  : "none",
                                "&:hover": {
                                  borderColor: state.isFocused
                                    ? "none"
                                    : "2px solid rgba(46, 55, 164, 0.1)",
                                },
                                borderRadius: "10px",
                                fontSize: "14px",
                                minHeight: "45px",
                              }),
                              dropdownIndicator: (base, state) => ({
                                ...base,
                                transform: state.selectProps.menuIsOpen
                                  ? "rotate(-180deg)"
                                  : "rotate(0)",
                                transition: "250ms",
                                width: "35px",
                                height: "35px",
                              }),
                            }}
                          />
                        </div>
                      </div>

                      <div className="col-12 col-md-6 col-xl-6">
                        <div className="form-group local-forms">
                          <label>
                            Assign to <span className="login-danger">*</span>
                          </label>
                          <Select
                            value={
                              formState?.assigned_to_id
                                ? (formState.assigned_to_type === "Doctor"
                                  ? doctorsList
                                  : staffList
                                ).find((option) => option.value === formState?.assigned_to_id)
                                : null
                            }
                            onChange={(e) => handleChange("assigned_to_id", e.value)}
                            options={formState?.assigned_to_type === "Doctor" ? doctorsList :
                              formState?.assigned_to_type === "BackopsUser" ? staffList : []}
                            id="search-commodity"
                            components={{
                              IndicatorSeparator: () => null,
                            }}
                            styles={{
                              menu: (base) => ({ ...base, zIndex: 9999 }),
                              control: (baseStyles, state) => ({
                                ...baseStyles,
                                borderColor: state.isFocused
                                  ? "none"
                                  : "2px solid rgba(46, 55, 164, 0.1);",
                                boxShadow: state.isFocused ? "0 0 0 1px #007A99" : "none",
                                "&:hover": {
                                  borderColor: state.isFocused ? "none" : "2px solid rgba(46, 55, 164, 0.1)",
                                },
                                borderRadius: "10px",
                                fontSize: "14px",
                                minHeight: "45px",
                              }),
                              dropdownIndicator: (base, state) => ({
                                ...base,
                                transform: state.selectProps.menuIsOpen ? "rotate(-180deg)" : "rotate(0)",
                                transition: "250ms",
                                width: "35px",
                                height: "35px",
                              }),
                            }}
                          />

                        </div>
                      </div>

                      <div className="col-12 col-md-6 col-xl-6">
                        <div className="form-group local-forms">
                          <label>
                            Status <span className="login-danger">*</span>
                          </label>
                          <Select
                            value={
                              statusList.find((option) => option.value === formState?.status) ||
                              null
                            }
                            onChange={(e) => handleChange("status", e.value)}
                            options={statusList || []}
                            id="search-commodity"
                            components={{
                              IndicatorSeparator: () => null,
                            }}
                            styles={{
                              menu: (base) => ({ ...base, zIndex: 9999 }),
                              control: (baseStyles, state) => ({
                                ...baseStyles,
                                borderColor: state.isFocused
                                  ? "none"
                                  : "2px solid rgba(46, 55, 164, 0.1);",
                                boxShadow: state.isFocused ? "0 0 0 1px #007A99" : "none",
                                "&:hover": {
                                  borderColor: state.isFocused ? "none" : "2px solid rgba(46, 55, 164, 0.1)",
                                },
                                borderRadius: "10px",
                                fontSize: "14px",
                                minHeight: "45px",
                              }),
                              dropdownIndicator: (base, state) => ({
                                ...base,
                                transform: state.selectProps.menuIsOpen ? "rotate(-180deg)" : "rotate(0)",
                                transition: "250ms",
                                width: "35px",
                                height: "35px",
                              }),
                            }}
                          />

                        </div>
                      </div>

                      {/* Chat Messages */}


                      <h4> Chats</h4>
                      <div className="chat-box" style={{ maxHeight: "400px", overflowY: "auto", padding: "10px", border: "1px solid #ddd", borderRadius: "5px" }}>



                        {messages?.map((reply) => {
                          const isCurrentUser = reply.repliable_type !== "Patient";
                          return (
                            <div key={reply.id} style={{
                              display: "flex",
                              flexDirection: "column",
                              alignItems: isCurrentUser ? "flex-end" : "flex-start",
                              marginBottom: "10px",
                            }}>
                              <div style={{
                                backgroundColor: isCurrentUser ? "#0067FF40" : "#f1f1f1",
                                padding: "10px",
                                borderRadius: "10px",
                                maxWidth: "70%",
                                display: 'flex',
                                flexDirection: "column",
                                gap: -10,
                                boxShadow: "0px 1px 3px rgba(0,0,0,0.2)"
                              }}>
                                {/* <strong>{isCurrentUser ? "You" : reply.repliable_type}</strong> */}
                                <p style={{ padding: '0px' }}>{reply.message}</p>
                                <small style={{
                                  fontSize: "12px",
                                  color: "#777",
                                  padding: '0px'
                                }}>
                                  {new Date(reply.created_at).toLocaleString()}
                                </small>
                              </div>
                            </div>
                          );
                        })}
                      </div>

                      {/* Input Box */}
                      <div className="input-box" style={{ marginTop: "10px", display: "flex", gap: "10px", alignItems: "center" }}>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Type your message..."
                          value={message}
                          onChange={(e) => setMessage(e.target.value)}
                          style={{ flex: 1 }}
                        // onKeyDown={(e) => {
                        //     if (e.key === "Enter") {
                        //         e.preventDefault(); // Prevents form submission (if applicable)
                        //         handleSendMessage();
                        //     }
                        // }}
                        />
                        {/* <button className="btn btn-primary" onClick={handleSendMessage}>
                                            <FeatherIcon icon="send" size={16} /> Send
                                        </button>

                                        <button className="btn btn-secondary" onClick={() => navigate("/admin/update_quires", { state: QueryData })}>
                                            <FeatherIcon icon="arrow-left" size={16} /> Back
                                        </button> */}
                      </div>


                      <div className="col-12 gap-10 m-10" style={{ marginTop: 10 }}>
                        <div className="doctor-submit text-end">
                          <button
                            type="submit"
                            className="btn btn-primary submit-form me-2 mr-5"
                          >
                            Submit
                          </button>

                          {/* <button
                            type="button"
                            className="btn btn-primary submit-form me-2 mr-5"
                            // onClick={() => navigate("/admin/Quires")}
                            onClick={() =>
                              navigate("/admin/reply_quires", { state: QueryData })
                            }
                          >
                            Reply
                          </button> */}

                          <button
                            type="button"
                            onClick={() => navigate("/admin/Quires")}
                            className="btn btn-primary cancel-form  me-2"
                          >
                            Cancel
                          </button>
                        </div>
                      </div>


                    </div>
                  </form>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default UpdateQuery;
